import { render } from "./salary.vue?vue&type=template&id=d1c5cd6c&scoped=true"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"

import "./salary.vue?vue&type=style&index=0&id=d1c5cd6c&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c5cd6c"]])

export default __exports__